var CurrentUser = require("lib/account/CurrentUser");
var Spinner = require("components/utility/Spinner");
var DistrictSearch = require("components/org/roster/DistrictSearch");
var Glyphicon = require("components/utility/icons/Glyphicon");
import ReactSelect from "react-select";

import { Link } from "react-router-dom";


class CleverLinkDistrictOrg extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = { canonicalDistrict: null, districtOrgs: [], selectedDistrictOrg: null }
	}

	selectCanonicalDistrict(selected) {
		this.setState({ canonicalDistrict: selected }, this.fetchDistrictOrgs)
	}

	renderDistrictSearch() {
		if (this.state.canonicalDistrict) {
			var nameRow = (
				<td>
					{ this.state.canonicalDistrict.value.name }
				</td>
			)
			var idRow = (
				<td>
					{ this.state.canonicalDistrict.value.id }
				</td>
			)
		}
		return (
			<table className="table">
				<thead>
					<tr>
						<th>
							1.a Search for Canonical ID
						</th>
						<th>
							Selected district
						</th>
						<th>
							Canonical ID
						</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>
							<DistrictSearch ref="search" onSelect={ this.selectCanonicalDistrict } selectedDistrict={ this.state.canonicalDistrict } />
						</td>
						{ nameRow }
						{ idRow }
					</tr>
				</tbody>
			</table>
		)
	}

	renderCanonicalDistrict() {
		var canonicalDistrict = this.state.canonicalDistrict
		var schoolRows = _.map(canonicalDistrict.value.schools, (school, s) => {
			return (
				<tr key={s}>
					<td>
						{school.id}
					</td>
					<td>
						{ school.name }
					</td>
				</tr>
			)
		})
		return (
			<table className="table">
				<thead>
					<tr>
						<th>
							1.b Check Canonical School IDs
						</th>
						<th>
							Name
						</th>
					</tr>

				</thead>
				<tbody>
					{ schoolRows }
				</tbody>
			</table>
		)
	}

	onSelectedDistrictOrg(selected) {
		console.log("======================", selected)
		this.setState({selectedDistrictOrg: selected})
	}

	renderLinkingActions() {
		
		if (this.state.districtOrgs && this.state.districtOrgs.length > 0) {
			var options = _.map(this.state.districtOrgs, (districtOrg) => {
				return {value: districtOrg, label: districtOrg.name}
			})
			console.log("OPTIONS", options)
			var schoolOrgSelect = (<ReactSelect name="district-org" value={ this.state.selectedDistrictOrg }
							options={ options } onChange={ this.onSelectedDistrictOrg } />)

			if (this.state.selectedDistrictOrg) {
				var canonicalLinkButton = (
					<button className="btn btn-primary" onClick={this.linkCanonicalOrg}>Link Org</button>
				)
			}
		} else {
			var schoolOrgSelect = "No District orgs selected"
		}
		return (
			<table className="table">
				<thead>
					<tr>
						<th>
							1.c.a Link with canonical Search (preferred)
						</th>
						<th>
							1.c.b Link with District Org ID
						</th>
						<th>
							1.c.c Create new District Org
						</th>
					</tr>

				</thead>
				<tbody>
					<tr>
						<td>
							{ schoolOrgSelect }
						</td>
						<td>
							<input className="form-control" ref="district_org_id" type="text" onUpdate={this.forceUpdtate} placeholder="District Org ID" />
						</td>
						<td>
							<input className="form-control" ref="district_canonical_id" type="text" placeholder="District Canonical ID" />
						</td>
					</tr>
					<tr>
						<td>
							{ canonicalLinkButton }
						</td>
						<td>
							<button className="btn btn-default" onClick={this.linkDistrictOrgWithID}>Link Org</button>
						</td>
						<td>
							<button className="btn btn-default" onClick={this.createNewDistrictOrg}>Create new Org</button>
						</td>
					</tr>
					{ this.renderExplanations() }
				</tbody>
			</table>
		)
	}

	renderLinkView() {
		var linkedDistrictOrg = this.props.accessToken.district_org
		return (
			<div>
				Access Token linked with district org: <b>{linkedDistrictOrg.name} | {linkedDistrictOrg.id}</b>
			</div>
		)
	}

	renderView() {
		if (this.state.canonicalDistrict) {
			var canonicalDistrict = this.renderCanonicalDistrict()
		}
		if (this.props.accessToken.district_org != null) {
			var linkView = this.renderLinkView()
		}
		return (
			<div>
				{ this.renderDistrictSearch() }
				{ canonicalDistrict }
				{ this.renderLinkingActions() }
				{ linkView }
			</div>
		)
	}
	renderExplanations() {
		if (this.props.accessToken.district_org != null) {
			var districtOrgID = this.props.accessToken.district_org.id
			var manualDistrictOrgID = districtOrgID
		} else {
			if (this.state.selectedDistrictOrg && this.state.selectedDistrictOrg.value) {
				var districtOrgID = this.state.selectedDistrictOrg.value.id
			} else {
				var districtOrgID = "?"
			}
			if (this.refs.district_org_id && this.refs.district_org_id.value != "") {
				var manualDistrictOrgID = this.refs.district_org_id.value
			} else {
				manualDistrictOrgID = "?"
			}
		}

		return (
			<tr>
				<td>
					<textArea className="form-control" disabled="true" rows={7}>
						{"#This will attach the selected district org to the CleverAuthToken and cleverDistrict: \r\naccess_token = CleverAccessToken.find("+this.props.accessToken.id+")\r\naccess_token.district_org_id == "+ districtOrgID+"\r\nclever_district = access_token.clever_district\r\nclever_district.district_org_id == "+ districtOrgID}
					</textArea>
				</td>
				<td>
					<textArea className="form-control" disabled="true" rows={7}>
						{"#This will attach the selected district org to the CleverAuthToken and cleverDistrict: \r\naccess_token = CleverAccessToken.find("+this.props.accessToken.id+")\r\naccess_token.district_org_id == "+ manualDistrictOrgID+"\r\nclever_district = access_token.clever_district\r\nclever_district.district_org_id == "+ manualDistrictOrgID}
					</textArea>
				</td>
				<td>
					<textArea className="form-control" disabled="true" rows={7}>
					{"#This will create a new district org. Canonical ID optional. \r\naccess_token = CleverAccessToken.find("+this.props.accessToken.id+")\r\naccess_token.district_org_id == "+ manualDistrictOrgID+"\r\nclever_district = access_token.clever_district\r\nclever_district.district_org_id == "+ manualDistrictOrgID}
					</textArea>
				</td>
			</tr>
		)
	}

	render() {

		var view = this.renderView()

		if (this.state.loading) {
			var spinner = <Spinner placeholder={true} scale={1.7} />
		}
		return (
			<div className="CleverLinkDistrictOrg">
				{ view }
				{ spinner }
			</div>
		);
	}
	fetchDistrictOrgs() {
		if (this.state.canonicalDistrict && this.state.canonicalDistrict.value) {
			this.setState({loading: true})

			CurrentUser.api().getDistrictOrgs({canonical_id: this.state.canonicalDistrict.value.id}, $wr.apiHandler((response) => {
				if (response.district_orgs.length == 1) {
					var selectedDistrictOrg = {value: response.district_orgs[0], label: response.district_orgs[0].name}
					this.setState({ loading: false, districtOrgs: response.district_orgs, selectedDistrictOrg: selectedDistrictOrg });
				} else {
					this.setState({ loading: false, districtOrgs: response.district_orgs });
				}
			}));
		}
	}

	linkCanonicalOrg() {
		this.setState({loading: true})
		const districtOrg = this.state.selectedDistrictOrg.value
		CurrentUser.api().patchDistrictOrg(districtOrg.id, {clever_access_token_id: this.props.accessToken.id}, $wr.apiHandler((response) => {
			this.updateAccessToken(response.district_org)
		}));
	}

	linkDistrictOrgWithID() {
		var districtOrgID = this.refs.district_org_id.value

		if (districtOrgID != null) {
			this.setState({loading: true})
			
			CurrentUser.api().patchDistrictOrg(districtOrgID, {clever_access_token_id: this.props.accessToken.id}, $wr.apiHandler((response) => {
				this.updateAccessToken(response.district_org)
			}));
		}
	}

	createNewDistrictOrg() {
		this.setState({loading: true})
		const token = this.props.accessToken
		var district_org = {name: token.district.name}

		var canonicalId = this.refs.district_canonical_id.value
		if (canonicalId) {
			district_org["canonical_id"] = canonicalId
		}

		CurrentUser.api().postDistrictOrgs({ district_org, clever_access_token_id: token.id}, $wr.apiHandler((response) => {
			this.updateAccessToken(response.district_org)
		}));
	}
	updateAccessToken(districtOrg) {
		this.setState({loading: false})
		this.props.onSelect(districtOrg)
	}
};

CleverLinkDistrictOrg.propTypes = PageStrictPropTypes({
});

module.exports = CleverLinkDistrictOrg;


// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/CleverLinkDistrictOrg.js